/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    export class QueryConfigurationService extends services.DataService<Wars.Domain.Model.QueryConfiguration> {
        constructor(injectedBreeze: typeof breeze, $q: angular.IQService) {
            super(injectedBreeze, $q);

        }

        public createNewQueryParameter(): Wars.Domain.Model.OperationParameter{
            return this.createNewEntity<Wars.Domain.Model.OperationParameter>("OperationParameter");
        }

        public createNewQueryConfiguration(): Wars.Domain.Model.QueryConfiguration {
            return this.createNewEntity<Wars.Domain.Model.QueryConfiguration>("QueryConfiguration");
        }

        public getDataSources(id?: string): angular.IPromise<Wars.Domain.Model.DataSource[]> {
            let query = this.breezeModule.EntityQuery
                .from("DataSources");

            if (id) {
                query = query.where("processConfiguration_id", "==", id);
            } else {
                query = query.where("processConfiguration_id", "==", null);
            }

                query = query.expand("operations.parameters.parmeterSchema");

            return <any>this.executeQuery(query);

        }

        public getQueryConfiguration(id: string):angular.IPromise<Wars.Domain.Model.QueryConfiguration>{
            return this.fetchById(id, "QueryConfiguration");
        }

        public getSchemaProperty(id: string): angular.IPromise<Wars.Domain.Model.SchemaProperty> {
            return <any>this.fetchById(id, "SchemaProperty");
        }

        public getAllQueryConfigurations(processConfigId: string): angular.IPromise<Wars.Domain.Model.QueryConfiguration[]> {
            var expand = "parameters.treeItem, " +
                "myDataOperation.resultSchema.properties, " +
                "myDataOperation.myDataSource.objectSchemas.properties";

            var query = this.breezeModule.EntityQuery
                .from("QueryConfigurations")
                .where("processConfiguration_id", "==", processConfigId)
                .expand(expand);

            return this.executeQuery(query);
        }
    }
}

warsApp.registerService('QueryConfigurationService', ['breeze', '$q'])